import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import { Button, message } from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ListingNoAvailable, {
  isInVentoryCountsEmpty,
} from '~pages/pms-dashboard/properties/listing-management/listingNoAvailable';

export default class PropertyDetailWrapper extends React.Component {
  constructor() {
    super();

    this.state = {
      loading: false,
      isShowListingEmptyModal: false,
    };
  }

  // 处理 listing available 为0
  isShowPop = hasInVentory => {
    const { status } = this.props?.property;
    const { isShowListingEmptyModal } = this.state;
    if (status === 'PUBLISHED' && hasInVentory) {
      if (!isShowListingEmptyModal) {
        this.setState({ isShowListingEmptyModal: true });
        return true;
      }
    }
    return false;
  };

  handleSave = hasInVentory => {
    const { onClickSave, t, isPublished } = this.props;
    if (this.isShowPop(hasInVentory)) {
      return;
    }
    this.setState({ loading: true });
    const promise = onClickSave();
    if (!promise || !promise.then) {
      throw new Error('onClickSave must return a promise!');
    }
    promise
      .then(({ isUpdated, isShowUpdateHint }) => {
        if (isUpdated && !isPublished) {
          message.success(t('cms:cms.properties.edit.message.save_success'));
          return;
        }
        if (isUpdated && isShowUpdateHint && isPublished) {
          message.success(t('cms:cms.properties.edit.message.update_success'));
        }
      })
      .catch(e => {
        message.error(`${t('cms:cms.message.error')}: ${e.message}`);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const {
      t,
      children,
      isPublished,
      isHidden,
      isPendingApprovalSection,
      draft,
      property,
      hiddenSubmit,
    } = this.props;
    const { isShowListingEmptyModal } = this.state;
    const hasInVentory = isInVentoryCountsEmpty(property?.unitTypes?.edges);
    return (
      <div
        className={classNames('property-detail-wrapper', {
          'property-detail-wrapper--hidden': isHidden,
          'property-detail-wrapper--reminder': draft,
        })}
      >
        <div
          className={classNames('property-detail-wrapper__content', {
            'property-detail-wrapper__content--without-footer': hiddenSubmit,
          })}
        >
          {children}
        </div>
        <div
          className={classNames('property-detail-wrapper__footer', {
            'property-detail-wrapper__footer--hidden': hiddenSubmit,
          })}
        >
          <div className="property-detail-wrapper__warning">
            <If condition={isPublished}>
              <InfoCircleFilled className="property-detail-wrapper__warning-icon" />
              <span className="property-detail-wrapper__warning-text">
                <Choose>
                  <When condition={isPendingApprovalSection}>
                    {t('cms:cms.form.warning.landlord.check_before_publish')}
                  </When>
                  <Otherwise>{t('cms:cms.form.warning.landlord.published_tips')}</Otherwise>
                </Choose>
              </span>
            </If>
          </div>
          <ListingNoAvailable
            confirmHandle={() => {
              this.handleSave(hasInVentory);
              this.setState({ isShowListingEmptyModal: false });
            }}
            NewClass={'property-detail-wrapper__publish-right-popUp'}
            isShow={isShowListingEmptyModal}
            onCancel={() => {
              this.setState({ isShowListingEmptyModal: false });
            }}
          />
          <Button
            onClick={() => {
              this.handleSave(hasInVentory);
            }}
            className="property-detail-wrapper__btn"
            type="primary"
            loading={this.state.loading}
            disabled={isShowListingEmptyModal}
          >
            {' '}
            {isPublished
              ? t('cms:cms.property.listing_management.btn.publish_to_studentcom')
              : t('cms:cms.form.button.save')}
          </Button>
        </div>
      </div>
    );
  }
}

PropertyDetailWrapper.propTypes = {
  t: PropTypes.func,
  children: PropTypes.any,
  isPublished: PropTypes.bool,
  onClickSave: PropTypes.func,
  isHidden: PropTypes.bool,
  isPendingApprovalSection: PropTypes.bool,
  draft: PropTypes.any,
  property: PropTypes.object,
  hiddenSubmit: PropTypes.bool,
};

PropertyDetailWrapper.defaultProps = {
  t: () => {},
  children: '',
  isPublished: false,
  onClickSave: () => {},
  isHidden: false,
  isPendingApprovalSection: false,
  draft: null,
  property: {},
  hiddenSubmit: false,
};
